import { useState } from 'react';
import axios from 'axios';

const ROLES = [
  { key: 'patient', icon: '🏥', title: 'Patient', desc: 'Book nurses, lab tests & medicines' },
];

export default function RoleSelectionModal({ googleData, credential, onSuccess, onClose }) {
  const [selectedRole, setSelectedRole] = useState('patient');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRegister = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/api/auth/google-register', {
        credential,
        role: selectedRole,
      });

      // Call parent callback with user data
      onSuccess(response.data);
    } catch (err) {
      console.error('Registration error:', err);
      setError(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '32px 24px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: 600 }}>
            Welcome to SehatSehul! 👋
          </h2>
          <p style={{ margin: '0', color: '#666', fontSize: '14px' }}>
            {googleData.firstName}, select your role to continue
          </p>
        </div>

        {/* Google User Info */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            marginBottom: '24px',
          }}
        >
          {googleData.avatar && (
            <img
              src={googleData.avatar}
              alt={googleData.firstName}
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
              }}
            />
          )}
          <div>
            <div style={{ fontWeight: 600, fontSize: '14px' }}>
              {googleData.firstName} {googleData.lastName}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {googleData.email}
            </div>
          </div>
        </div>

        {/* Role Selection */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '12px', fontWeight: 600, fontSize: '14px' }}>
            Select Your Role
          </label>
          {ROLES.map((role) => (
            <div
              key={role.key}
              onClick={() => setSelectedRole(role.key)}
              style={{
                padding: '12px 16px',
                borderRadius: '8px',
                border: selectedRole === role.key ? '2px solid var(--teal)' : '1px solid #e0e0e0',
                backgroundColor: selectedRole === role.key ? '#e8f5f4' : 'white',
                cursor: 'pointer',
                marginBottom: '8px',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = selectedRole === role.key ? '#e8f5f4' : '#f9f9f9';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = selectedRole === role.key ? '#e8f5f4' : 'white';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '18px' }}>{role.icon}</span>
                <div>
                  <div style={{ fontWeight: 600, fontSize: '14px' }}>{role.title}</div>
                  <div style={{ fontSize: '12px', color: '#666' }}>{role.desc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Error Message */}
        {error && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginBottom: '16px', padding: '8px 12px', backgroundColor: '#ffebee', borderRadius: '4px' }}>
            {error}
          </div>
        )}

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              flex: 1,
              padding: '12px 16px',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              backgroundColor: 'white',
              color: '#333',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.5 : 1,
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleRegister}
            disabled={loading}
            style={{
              flex: 1,
              padding: '12px 16px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: 'var(--teal)',
              color: 'white',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Creating Account...' : 'Continue'}
          </button>
        </div>

        {/* Google-only Message */}
        <p style={{ fontSize: '12px', color: '#999', textAlign: 'center', marginTop: '16px' }}>
          Currently, Google Sign-In is available for patients only.
        </p>
      </div>
    </div>
  );
}
